export default "__VITE_ASSET__C75x99jd__"